<div class="filters">
  @if (!hideTextSearch) {
    <input
      (keyup)="setFilter()"
      [(ngModel)]="filterString"
      class="search"
      id="SearchFilter"
      placeholder="Type to Filter"
      />
  }
  @if (showAddFilter) {
    <div class="service-name-container header-filter-container">
      <app-filter-select
        placeholder="Filter by Service..."
        optionLabel="name"
        optionValue="id"
        filterBy="name"
        [options]="filteredServices"
        [filter]="true"
        [showClear]="true"
        (onChange)="serviceChanged($event)"
        [(ngModel)]="selectedServiceId"
        >
        <ng-template appFilterSelectFilter let-options="options">
          <div class="dropdown-filter-container">
            <div class="p-inputgroup" (click)="$event.stopPropagation()">
              <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
              <input
                type="text"
                pInputText
                placeholder="Filter"
                (keyup)="serviceFilterChangedDebounced($event)"
                [(ngModel)]="serviceSearchText"
                />
            </div>
            <button
              type="button"
              class="app-filter-select__clear-btn"
              [ngClass]="{ 'configs-loading': servicesLoading }"
              (click)="serviceFilterChangedDebounced($event)"
              aria-label="Clear filter"
              >
              <i class="pi pi-times" aria-hidden="true"></i>
            </button>
            @if (servicesLoading) {
              <div class="spinner"></div>
            }
          </div>
        </ng-template>
      </app-filter-select>
    </div>
  }
  @if (showAddFilter) {
    <div class="identity-name-container header-filter-container">
      <app-filter-select
        placeholder="Filter by Identity..."
        optionLabel="name"
        optionValue="id"
        filterBy="name"
        [options]="filteredIdentities"
        [filter]="true"
        [showClear]="true"
        (onChange)="identityChanged($event)"
        [(ngModel)]="selectedIdentityId"
        >
        <ng-template appFilterSelectFilter let-options="options">
          <div class="dropdown-filter-container">
            <div class="p-inputgroup" (click)="$event.stopPropagation()">
              <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
              <input
                type="text"
                pInputText
                placeholder="Filter"
                (keyup)="identityFilterChangedDebounced($event)"
                [(ngModel)]="identitySearchText"
                />
            </div>
            <button
              type="button"
              class="app-filter-select__clear-btn"
              [ngClass]="{ 'configs-loading': servicesLoading }"
              (click)="identityFilterChangedDebounced($event)"
              aria-label="Clear filter"
              >
              <i class="pi pi-times" aria-hidden="true"></i>
            </button>
            @if (identitiesLoading) {
              <div class="spinner"></div>
            }
          </div>
        </ng-template>
      </app-filter-select>
    </div>
  }
  @if (showAddFilter) {
    <div class="calendar left-side-filter">
      @if (hideTextSearch && showAddFilter) {
        <mat-form-field appearance="outline" class="side-filter-date-filter">
          <mat-label>Select Time Frame</mat-label>
          <mat-date-range-input [rangePicker]="picker" (click)="picker.open()">
            <input
              matStartDate
              matInput
              readonly
              [(ngModel)]="startDate"
              [min]="minDate"
              [max]="maxDate"
              (dateChange)="onDateRangeChanged()"
              />
            <input
              matEndDate
              matInput
              readonly
              [(ngModel)]="endDate"
              [min]="minDate"
              [max]="maxDate"
              (dateChange)="onDateRangeChanged()"
              />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker [calendarHeaderComponent]="rangeHeader"></mat-date-range-picker>
        </mat-form-field>
      }
    </div>
  }
  @if (false && hideTextSearch && showAddFilter) {
    <div class="add-filter-container add-filter-left" (click)="showFilters($event)" #filterButton [ngClass]="{'filters-added': filtersAdded, 'add-filter-open': showAdditionalFilters}">
      <div class="add-icon icon-Icon_Add"></div>
      <span class="add-icon-label">{{filtersAdded ? 'Edit' : 'Add'}} Filters</span>
    </div>
  }

  <div class="filtered-columns-list" id="ColumnFilterContainer">
    @for (filter of filters; track filter) {
      <div
        (click)="removeFilter(filter)"
        class="filtered-column-item ag-dnd-ghost ag-unselectable ag-theme-alpine"
        id="ColumnVisibility_{{ filter.filterName }}"
        title="Remove filter"
        >
        <span class="ag-dnd-ghost-icon">
          <span class="ag-icon ag-icon-filter"></span>
        </span>
        <div class="ag-dnd-ghost-label">{{ filter.filterName }}: {{ filter.label | truncate : 25 }}</div>
      </div>
    }
  </div>
  <div id="paginationControls">
    @if (!hideTextSearch && showAddFilter) {
      <div class="add-filter-container" (click)="showFilters($event)" #filterButton [ngClass]="{'filters-added': filtersAdded, 'add-filter-open': showAdditionalFilters}">
        <div class="add-icon icon-Icon_Add"></div>
        <span class="add-icon-label">{{filtersAdded ? 'Edit' : 'Add'}} Filters</span>
      </div>
    }
    @if (isTimeSearchAvailable) {
      <div (clickOutside)="closeTime()" id="TimeSearch">
        <div (click)="showTimeSelect()" id="TimeSelectButton">{{ dateFilter }}</div>
        @if (isNotDialLogs) {
          <div [ngClass]="{ open: isSelectingTime }"
            class="timeSearchList" id="TimeSearchList">
            <div (click)="pickDateFilter('1h')" [ngClass]="{ selected: dateFilter === '1h' }" class="time">1h</div>
            <div (click)="pickDateFilter('6h')" [ngClass]="{ selected: dateFilter === '6h' }" class="time">6h</div>
            <div (click)="pickDateFilter('24h')" [ngClass]="{ selected: dateFilter === '24h' }" class="time">24h</div>
            <div (click)="pickDateFilter('7d')" [ngClass]="{ selected: dateFilter === '7d' }" class="time">7d</div>
            @if (isNotDialLogs) {
              <div (click)="pickDateFilter('30d')" [ngClass]="{ selected: dateFilter === '30d' }" class="time">30d</div>
            }
            @if (isNotDialLogs) {
              <div (click)="pickDateFilter('1m')" [ngClass]="{ selected: dateFilter === '1m' }" class="time">1m</div>
            }
            @if (isNotDialLogs) {
              <div (click)="pickDateFilter('6m')" [ngClass]="{ selected: dateFilter === '6m' }" class="time">6m</div>
            }
            @if (isNotDialLogs) {
              <div (click)="pickDateFilter('12m')" [ngClass]="{ selected: dateFilter === 'All' }" class="time">All</div>
            }
          </div>
        }
        @if (!isNotDialLogs) {
          <div [ngClass]="{ open: isSelectingTime  }"
            class="timeSearchList dialLogTimeSearchList" id="DialLogTimeSearchList">
            <div (click)="pickDateFilter('1h')" [ngClass]="{ selected: dateFilter === '1h' }" class="time">1h</div>
            <div (click)="pickDateFilter('6h')" [ngClass]="{ selected: dateFilter === '6h' }" class="time">6h</div>
            <div (click)="pickDateFilter('24h')" [ngClass]="{ selected: dateFilter === '24h' }" class="time">24h</div>
            <div (click)="pickDateFilter('7d')" [ngClass]="{ selected: dateFilter === '7d' }" class="time">7d</div>
          </div>
        }
      </div>
    }
    @if ((isTimeSearchAvailable || showCalendarFilter) && !hideTextSearch) {
      <div class="calendar">
        <app-date-time-range-picker
          [(ngModel)]="rangeDates"
          [minDate]="minDate"
          placeholder="Select Time Frame"
          [showButtonBar]="true"
          (ngModelChange)="close()"
        ></app-date-time-range-picker>
      </div>
    }
    @if ((isTimeSearchAvailable || showCalendarFilter) && !hideTextSearch) {
      <div class="timeBox">
        <app-toggle-button
          (onChange)="handleTimeChange($event)"
          [(ngModel)]="isUTC"
          [styleClass]="styleClass"
          [style]="style"
          iconPos="left"
          offIcon="pi pi-clock"
          offLabel="Local"
          onIcon="pi pi-clock"
          onLabel="UTC"
        ></app-toggle-button>
      </div>
    }
    <div class="counters">
      {{ filterService.getStartElementNumber() }}-{{ filterService.getLastElementNumber() }} of
      {{ filterService.getTotalElements() }}
    </div>
    <div
      (click)="prev()"
            [ngClass]="{
                disabled: filterService.isFirstPage() || !filterService.isUsingPagination()
            }"
      class="navigate prev icon-prev"
    ></div>
    <div
      (click)="next()"
            [ngClass]="{
                disabled: filterService.isLastPage() || !filterService.isUsingPagination()
            }"
      class="navigate next icon-next"
    ></div>
  </div>
</div>
@if (showAdditionalFilters) {
  <div
    class="dropdown-container"
    [ngClass]="{'dropdown-loading': servicesLoading}"
    [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
    (clickOutside)="closeFilters()"
    #filterMenu
    >
  </div>
}
